export function limit(text, length) {
    if (text == null) return ""
    return text.length > length ? text.slice(0, length) + '...' : text
}

export function parseToMoney(text, showDefault = false) {
    if (text == null) return showDefault === true ? '0 Ft' : null;
    return text.toLocaleString() + ' Ft'
}

export function parseToHUF(amount) {
    if(amount == null) return "0 Ft"
    return new Intl.NumberFormat('hu-HU', {
        style: 'currency',
        currency: 'HUF',
        useGrouping: true,
        maximumFractionDigits: 0
    }).format(amount);
}

export const huDateFormatter = new Intl.DateTimeFormat('hu-HU', {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
});